module.exports = __webpack_public_path__ + "static/media/RetroSprint1Audio1.97c1f981.mp3";